import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import MikrotikV2Service from '../../services/mikrotikV2.service';

const SelectPanelesMikrotikV2 = ({id, value, onChange, isInvalid, isClearable,isMulti,isDisabled,modalTicket, nodoName}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const actualizar = async() =>{
        await MikrotikV2Service.getAllPaneles().then((response) => {
            if(nodoName){
                if(response?.length > 0){
                    const filtro = response.filter((nP)=> nP?.nodo === nodoName)
                    setItems(filtro);
                }
            }else{
                setItems(response);
            }
        });
    }
    useEffect(() => {
        actualizar();
    }, [nodoName]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    useEffect(() => {
        const newOptions = items?.map((item) => {
            return {
                value: item?.nombre,
                label: item?.nombre,
                ...item
            };
        });
        setOptions(newOptions);
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === value)
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value?.map(va=>{
                const item = items?.find(it=>it?.nombre === va);
                if(item){
                    return {
                        label:item?.nombre,
                        value:item?.nombre,
                        ...item
                    };
                }
                return null
            }))
        }else{
            setSelectedValue(null)
        }
    }, [items,value]);

    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
            isDisabled={isDisabled && modalTicket}
        />
    );
};

SelectPanelesMikrotikV2.defaultProps = {
    isClearable: false
};

export default SelectPanelesMikrotikV2;
